import { DetailedHTMLProps, HTMLAttributes, useEffect } from 'react';

import { useToastSelector } from 'src/store';

import { ToastItem } from './components';

import styles from './ToastBox.module.scss';


type TProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export function ToastBox(props: TProps) {
	const items = useToastSelector();

	console.log('ToastBox');

	useEffect(() => {
		console.log('ToastBox CHANGE');
	}, [items]);

	if (items.length <= 0) {
		return (
			<></>
		);
	}

	const { className = '' } = props;

	const classNames = [styles.box];

	if (className) {
		classNames.push(className);
	}

	return (
		<div className={ classNames.join(' ') }>
			{ items.length > 0 &&
				items.map((item, index) => <ToastItem index={ index } item={ item } />)
			}
		</div>
	);
}
